module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robert Hellenga\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Robert Hellenga")]), _vm._v(" received his B.A. from the University of Michigan and studied at Queen's University in Belfast and the University of North Carolina before completing a Ph.D. in English Literature at Princeton University. He is a professor at Knox College in Galesburg, Illinois, and the author of the novels "), _c('I', [_vm._v("The Sixteen Pleasures")]), _vm._v(", "), _c('I', [_vm._v("The Fall of a Sparrow")]), _vm._v(", "), _c('I', [_vm._v("Blues Lessons")]), _vm._v(", and "), _c('I', [_vm._v("Philosophy Made Simple")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ehu1fq/tc-custom/9780316026307.jpg?1736424837001",
      "alt": "This image is the cover for the book Italian Lover"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Italian Lover\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An exhilarating novel of romance, art, and food in Florence, featuring the beloved Margot Harrington, who graced Robert Hellenga's "), _c('i', [_vm._v("The Sixteen Pleasures")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v(" Margot Harrington's memoir about her discovery in Florence of a priceless masterwork of Renaissance erotica -- and the misguided love affair it inspired - is now, 25 years later, being made into a movie. Margot, with the help of her lover, Woody, writes a script that she thinks will validate her life. Of course their script is not used, but never mind -- happy endings are the best endings for movies, as Margot eventually comes to see. "), _c('br'), _c('br'), _vm._v(" At the former convent in Florence where "), _c('i', [_vm._v("The Sixteen Pleasures")]), _vm._v(" -- now called "), _c('i', [_vm._v("The Italian Lover")]), _vm._v(" - - is being filmed, Margot enters into a drama she never imagined, where her ideas of home, love, art, and aging collide with the imperatives of commerce and the unknowability of other cultures and other people.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Little, Brown and Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0